import React, { Component } from 'react';
import kindbody from 'assets/logos/kindbody.svg';
import './styles.css';
import Navigation from '../../containers/NavigationContainer';

export default class Header extends Component {
  render() {
    return (
      <div className="header">
        <Navigation />
        <img src={kindbody} alt="kindbody" />
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Header/Header.js